function $5e5d11e830c78975$export$4d5c9005feaec1dd(a, b) {
    return a - b;
}
function $5e5d11e830c78975$export$e16d8520af44a096(a, b) {
    return a + b;
}
function $5e5d11e830c78975$export$c8ed8513565250d(a, b) {
    return a / b;
}


console.log((0, $5e5d11e830c78975$export$4d5c9005feaec1dd)(15, 2));
console.log((0, $5e5d11e830c78975$export$e16d8520af44a096)(233, 23033));
console.log((0, $5e5d11e830c78975$export$c8ed8513565250d)(6, 2));


//# sourceMappingURL=Parcel.acc78053.js.map
